import { useMemo } from "react";
import LogoutIcon from "../Dashboard/IconsCode/LogoutIcon";
import BrandDashboardIcon from "./BrandDashboardIcon";

function BrandSideMenu({ activeTab, setActiveTab, openModal }) {
  const user = useMemo(() => ({ name: "ادمین" }), []);

  return (
    <div className="w-1/6 h-screen flex flex-col justify-between items-end">
      <div>
        <div className="flex flex-row-reverse items-center justify-center h-20">
          <img src="/image/Logo.png" alt="Brand panel" className="w-10" />
          <p className="t-purpleDark font-extrabold mr-2">پنل مدیریت برند</p>
        </div>

        <div className="flex flex-row-reverse items-center bg-white rounded-lg mx-10 p-2 mt-5 mb-12">
          <img
            src="/image/icon/userIcon.png"
            alt="User"
            className="w-10"
          />
          <p className="text-sm mr-2">{user.name}</p>
        </div>

        <button
          onClick={() => setActiveTab(0)}
          className={`flex flex-row-reverse items-center
                        my-5 w-60 rounded-lg px-4 py-2 mx-10
                        ${activeTab === 0 && "bg-purpleDark shadow-xl"}`}
        >
          <BrandDashboardIcon
            width={40}
            height={40}
            fill={activeTab === 0 ? "#fff" : "#4355B9"}
          />
          <p
            className={`${activeTab === 0 ? "text-white font-semibold" : "t-grayDark"} 
                             mr-3 text-sm`}
          >
            داشبورد برند
          </p>
        </button>
      </div>

      <div
        onClick={() => openModal(true)}
        className="mb-16 mx-4 flex flex-row-reverse items-center mr-14 hover:cursor-pointer w-24"
      >
        <LogoutIcon width={28} height={28} fill="#4355B9" />
        <p className="t-grayDark text-sm mr-2">خروج</p>
      </div>
    </div>
  );
}

export default BrandSideMenu;
